import TextFieldConfiguration from '@/models/input-models/TextFieldConfiguration';

export default class SelectFieldConfiguration extends TextFieldConfiguration {
  constructor({ fieldName, key, label, type, rules, items = [] }) {
    super({ fieldName, key, label, type, rules });

    this.items = items;
  }
}
